import VueI18n from 'vue-i18n'
import de from './strings.de'
import en from './strings.en'
import Vue from 'vue'

Vue.use(VueI18n);

const strings = {
  de: de.de,
  en: en.en
};


export default new VueI18n({
  locale: 'de',
  messages: strings,
});
